import React, { useState, useEffect, useRef } from "react";
import EmptyState from "../../reusableComponents/ConfigEmptyState/EmptyState";
import GenerateReportModal from "./GenerateReportModal";
import { useAuth } from "../../context/API_Client";
import { customToast } from "../../reusableComponents/customToaster/customToast";
import LoadingLogoPage from "../loadingPage/loadingPage";
import { GeneratedReportTable } from "./GeneratedReportTable";
import { isEmpty, PAGE_LIST } from "../utils/utils";
import SmallModal from "../../reusableComponents/modals/SmallModal";
import { useNavigate, useParams } from "react-router-dom";

const currentDate = new Date();
const currentYear = currentDate.getFullYear();

let toDate = new Date();
toDate.setHours(23, 59, 59, 999);
let fromDate = new Date(toDate);
fromDate.setMonth(fromDate.getMonth() - 13);
fromDate.setHours(0, 0, 0, 0);

const GenerateReconReport = ({ operationPermissions }) => {
  const {
    getAllVisualizationData,
    getGenericReconciliationConfig,
    getGenericReconciliationRecordFiles,
    getReconciliationTags,
    getGenericReconciliationVisualizationData
  } = useAuth();
  const { reconId } = useParams();
  const [showGenerateReportModal, setShowGenerateReportModal] = useState();
  const [generatedReportData, setGeneratedReportData] = useState();
  const [loading, setLoading] = useState(true);
  const [dataLoading, setDataLoading] = useState(true);
  const [reconStatusData, setReconStatusData] = useState([]);
  const reportTypeOrignalDataRef = useRef([]);
  const [fileSetCodeData, setFileSetCodeData] = useState([]);
  const [fileSetCodeDataRaw, setFileSetCodeDataRaw] = useState([]);
  const [tags, setTags] = useState([]);
  const [toggleModal, setToggleModal] = useState(false);
  const [fileSetConfig, setFileSetConfig] = useState([]);
  const [dynamicFields, setDynamicFields] = useState("");
  const [fileSetCodesData, setFileSetCodesData] = useState("");
  const [pageNo, setPageNo] = useState(1);
  const [pageLimit, setPageLimit] = useState(PAGE_LIST[2]);
  const [totalDataCount, setTotalDataCount] = useState(100);
  const [currentRecon, setCurrentRecon] = useState("")

  const processReportTypeData = (data) => {
    let tempData = [];
    data.fileTypeConfigs.forEach((item, index) => {
      tempData.push({
        id: item.highValueStatus,
        title: item.highValueStatus,
        value: item.highValueStatus,
      });
      tempData.push({
        id: item.missingRecordStatus,
        title: item.missingRecordStatus,
        value: item.missingRecordStatus,
      });
    });
    tempData.push({
      id: data.successReconStatus,
      title: data.successReconStatus,
      value: data.successReconStatus,
    });
    setReconStatusData(tempData);
  };

  const processInsurerData = (data) => {
    let d = data.reduce((acc, item) => {
      const fileTypeCode = item.fileTypeCode;
      if (!acc[fileTypeCode]) {
        acc[fileTypeCode] = [];
      }
      acc[fileTypeCode].push(item);
      return acc;
    }, {});
    setFileSetCodeData(d);
    return d;
  };
  const processFieldsOfInterestData = (data) => {
    if (!isEmpty(data)) {
      let allFieldsData = []
      let fileSetCodes = data.map(item => (item.fileTypeCode))
      fileSetCodes = new Set(fileSetCodes)
      const fileSetCodeDataUnique = [...fileSetCodes]
      setFileSetCodesData(fileSetCodeDataUnique)
      data.forEach(item => {
        if (!isEmpty(item.fieldsOfInterest)) {
          allFieldsData.push(...item.fieldsOfInterest)
        }
      })
      if (!isEmpty(allFieldsData)) {
        allFieldsData = [...new Set(allFieldsData)];
        setDynamicFields(allFieldsData)
      }
    }
  };
  const getModalDataForGenerateReport = () => {
    getGenericReconciliationConfig(
      function (d) {
        const data = d.find(el => el.reconId == reconId)
        processReportTypeData(data);
        reportTypeOrignalDataRef.current = data?.fileTypeConfigs;
        getGenericReconciliationRecordFiles(
          reconId,
          function (d) {
            setFileSetConfig(d);
            setFileSetCodeDataRaw(d)
            processInsurerData(d, data);
            processFieldsOfInterestData(d)

            getReconciliationTags(
              reconId,
              (tags) => {
                setLoading(false);
                if (typeof tags == "object" && tags?.length) {
                  const cleanedArray = tags.filter(value =>
                    typeof value === "string" && value.trim() !== ""
                  );
                  setTags(cleanedArray);
                } else {
                  setTags([]);

                }
              },
              (err) => {
                customToast("error", "high", err);
              }
            );
            // setFileSetCodeData(data);
          },
          function (err) {
            customToast("error", "high", err);
          }
        );
      },
      function (err) {
        customToast("error", "high", err);
      }
    );
  };
  const getGeneratedReportData = () => {
    // setLoading(true);
    setDataLoading(true);
    getGenericReconciliationVisualizationData(
      "merchant_generic_recon_reports",
      reconId,
      {
        sort: { "addedTimestamp": "desc" },
        limit: pageLimit,
        offset: (pageNo - 1) * pageLimit
      },
      function (data) {
        setLoading(false);
        setDataLoading(false)
        setGeneratedReportData(data?.points);
        setTotalDataCount(data?.totalCount);
        if (currentRecon !== reconId || isEmpty(reconStatusData) && isEmpty(fileSetCodeData)) {
          setCurrentRecon(reconId)
          getModalDataForGenerateReport();
        } else {
          setDataLoading(false);
        }
      },
      function (errorMsg) {
        customToast("error", "high", errorMsg);
      }
    );
  };

  useEffect(() => {
    getGeneratedReportData();
  }, [pageNo, pageLimit, reconId]);
  const handleGenerateReport = () => {
    setShowGenerateReportModal(true);
  };
  const handleGenerateReportPopUpToggle = () => {
    setShowGenerateReportModal(false);
  };
  const handleModalClose = () => {
    setToggleModal(false);
    getGeneratedReportData();
    setGeneratedReportData([]);
  };

  return (
    <>
      {loading ? (
        <div className="content-wrapper" style={{ backgroundColor: "white" }}>
          <section
            className="content"
            style={{
              backgroundColor: "white",
              marginTop: "24px",
              height: "100vh",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <LoadingLogoPage />
          </section>
        </div>
      ) : generatedReportData === undefined ? (
        <>
          <div className="content-wrapper" style={{ background: "white" }}>
            <section className="content">
              <div className="recon-root-container">
                <EmptyState
                  image={<img src="/assets/report_icon.svg" alt="icon" />}
                  mainText={"Reports"}
                  subText={`Click ‘Generate Report’ to proceed with your reconciliation report`}
                  btnText={"Generate Report"}
                  btnFunction={handleGenerateReport}
                  btnPermission={operationPermissions.createGenReconReport}
                />
              </div>
            </section>
          </div>
        </>
      ) : (
        <GeneratedReportTable
          fileSetConfig={fileSetConfig}
          reportData={generatedReportData}
          operationPermissions={operationPermissions}
          handleGenerateReport={handleGenerateReport}
          loader={dataLoading}
          customPagination={true}
          pageNo={pageNo}
          setPageNo={setPageNo}
          pageLimit={pageLimit}
          setPageLimit={setPageLimit}
          totalDataCount={totalDataCount}

        />
      )}

      {showGenerateReportModal && (
        <GenerateReportModal
          fileSetCodesData={fileSetCodesData}
          open={showGenerateReportModal}
          onClose={handleGenerateReportPopUpToggle}
          reconStatusData={reconStatusData}
          fileSetCodeData={fileSetCodeDataRaw}
          dynamicFields={dynamicFields}
          tags={tags}
          operationPermissions={operationPermissions}
          reportTypeOrignalData={reportTypeOrignalDataRef?.current}
          setToggleModal={setToggleModal}
        />
      )}
      {toggleModal && (
        <SmallModal
          headerText={"Report generation in progress"}
          subHeaderText={
            "This may take a few moments. Once completed, you will be able to see that on the dashboard."
          }
          icon={<img src="/assets/infoIconForSmallModal.svg" />}
          toggleDialog={toggleModal}
          filledBtnText={"Got it"}
          filledBtnFunction={handleModalClose}
        />
      )}
    </>
  );
};

export default GenerateReconReport;
